var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iv-base-table-body-cell',_vm._b({attrs:{"render-when-empty":""}},'iv-base-table-body-cell',{ ..._vm.$attrs, ..._vm.$props },false),[_c('span',{staticClass:"badge badge-pill",class:_vm.badgeClass},[_c('i',{staticClass:"fas mr-1",class:_vm.iconClass}),_vm._v("\n        "+_vm._s(_vm.statusLabel)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }